
import Confirm from 'vux/src/components/confirm/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


export default {
directives: {
TransferDom
},
components: {
Confirm,
XDialog,
XButton,
Group,
GroupTitle,
Cell
},
created() {
console.log('created...')
this.initOrderInfo()
this.initShopInfo()
},
data () {
return {
dialogMsg: '',
showHideOnBlur:false,
shopName: '',
orderDetail: {},
shopId: this.$route.params.shopId,
orderId: this.$router.currentRoute.params.id,
voucherNo: this.$router.currentRoute.params.voucherNo,

consumeOrderData:{

confirm: false, // 默认关闭
confirmMsg: null, // 提示框内内容
refused: '取消核销',
agreed: '确认核销',
checkResult: null, // 审核结果
checkRemark: null, // 审核备注
orderNo: null
}
}
},
methods:{
onCancel () {
console.log('on cancel')
},
onHide () {
console.log('on hide')
},
onShow5 () {
this.$refs.confirm5.setInputValue('')
},
initOrderInfo(){
let shopId = this.shopId
let orderId = this.orderId
let _this = this;
_this.axios.get('/v1/shop/'+shopId+'/order/' + orderId, {
headers: {}
}).then(function (response) {
if (response.data.code == 0) {
_this.orderDetail = formateOrder(response.data.data)
}
}).catch(function (response) {
console.log(response);
});
},
initShopInfo(){
let shopId = this.shopId
let _this = this;
let uri = '/v1/shop/'+ shopId;
let params = null;
_this.axios.get(uri, params, {
headers: {}
}).then(function (response) {
if (response.data.code != undefined && response.data.code == 0) {

_this.shopName = response.data.data.name
} else {

console.log('处理错误提醒');
}
}).catch(function (response) {
console.log(response);

});
},
consumeOrderEvent(orderNo, type){
this.consumeOrderData.orderNo = orderNo

if (type == 1) {
this.consumeOrderData.checkResult = 'PASS'
this.consumeOrderData.confirmMsg = this.consumeOrderData.agreed
}else{
this.consumeOrderData.checkResult = 'REJECT'
this.consumeOrderData.confirmMsg = this.consumeOrderData.refused
}

this.consumeOrderData.confirm = true
},

onShowConsume(){
this.$refs.confirmConsume.setInputValue(this.consumeOrderData.confirmMsg)
},

onConfirmConsume(value){
let shopId = this.shopId
let checkResult = this.consumeOrderData.checkResult
let orderNo = this.consumeOrderData.orderNo
let voucherNo = this.voucherNo
let _this = this
_this.axios.post('/v1/shop/'+shopId+'/order/'+ orderNo +'/voucher/'+ voucherNo +'/consume', {
checkResult: checkResult,
checkRemark: value,
}).then(function (response) {
if (response.data.code == 0) {
_this.dialogMsg = '操作成功'
_this.showHideOnBlur = true

_this.initPageData()
} else {
_this.dialogMsg = response.data.msg
_this.showHideOnBlur = true
}
}).catch(function (response) {
console.log(response);
});
},
}
}

function formateOrder(data) {
let rs = {
orderNo: data.order_no,
goodsName: data.goods_name,
goodsNum: data.goods_num,
checkInTime: data.check_in_date,
checkInWeek: data.check_in_week,
checkOutTime: data.check_out_date,
checkOutWeek: data.check_out_week,
nights: data.nights, // 住了几晚
price: data.price,
totalPrice: data.total_price,
contact: data.guest_names,
sourceName: data.source_name,
createTime: data.created_at,
mobile: data.mobile_no,
statusName: data.status_desc,
status: data.status,
mobile: data.mobile_no
}
return rs
}



// WEBPACK FOOTER //
// ./src/components/order/Consumer.vue